"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react"); // tslint:disable-next-line: import-name


var react_iframe_comm_1 = require("react-iframe-comm");

var context_1 = require("../context");

var TFrameComponentClass =
/** @class */
function (_super) {
  __extends(TFrameComponentClass, _super);

  function TFrameComponentClass(props) {
    var _this = _super.call(this, props) || this;

    _this.iFrameRef = null;
    var springContext = props.springContext,
        data = props.data,
        padding = props.padding,
        pointColor = props.pointColor;
    _this.state = {
      postMessageData: {
        payload: {
          data: data,
          padding: padding,
          pointColor: pointColor,
          springContext: springContext
        },
        type: 'loaded'
      }
    };
    return _this;
  }

  TFrameComponentClass.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
        data = _a.data,
        padding = _a.padding,
        pointColor = _a.pointColor,
        springContext = _a.springContext;
    this.setState({
      postMessageData: {
        payload: {
          data: data,
          padding: padding,
          pointColor: pointColor,
          springContext: springContext
        },
        type: 'loaded'
      }
    });

    if (springContext && springContext !== prevProps.springContext) {
      this.forceUpdate();
    }
  };

  TFrameComponentClass.prototype.componentWillReceiveProps = function (nextProps) {
    var _this = this;

    var payload = {};
    Object.entries(nextProps).forEach(function (pair) {
      var _a;

      var key = pair['0']; // @ts-ignore

      if (nextProps[key] !== _this.props[key]) {
        payload = __assign({}, payload, (_a = {}, _a[key] = nextProps[key], _a));
      }
    });
    this.setState({
      postMessageData: {
        payload: payload,
        type: 'loaded'
      }
    });
  };

  TFrameComponentClass.prototype.shouldComponentUpdate = function (nextProps) {
    return nextProps.springContext.currentCells && nextProps.springContext.currentCells !== this.props.springContext.currentCells;
  };

  TFrameComponentClass.prototype.render = function () {
    var _a = this.props,
        height = _a.height,
        width = _a.width;
    var attributes = {
      height: height,
      src: 'http://localhost:8080/TContainer.html',
      width: width
    };
    return React.createElement(react_iframe_comm_1.default, {
      attributes: attributes,
      postMessageData: this.state.postMessageData
    });
  };

  TFrameComponentClass.defaultProps = {
    data: [[0], [0]],
    height: 400,
    padding: 0,
    pointColor: '#000000',
    springContext: __assign({}, context_1.initialSpringContext),
    width: 400
  };
  return TFrameComponentClass;
}(React.Component);

exports.TFrameComponentClass = TFrameComponentClass;

exports.TFrameComponent = function (props) {
  return React.createElement(context_1.SpringContext.Consumer, null, function (springContext) {
    return React.createElement(TFrameComponentClass, __assign({}, props, {
      springContext: springContext
    }));
  });
};